// extracted by mini-css-extract-plugin
module.exports = {"container":"notificationCard_container__VTuwq","manage":"notificationCard_manage__2YRDU","small":"notificationCard_small__5S0Mh","large":"notificationCard_large__3OjBi"};